import { makeStyles } from '@material-ui/core';
import React from 'react';

import { ReactComponent as TimelineEventSvg } from '../../../assets/timeline_event.svg';

export function TimelineSearchEventSvg(): React.ReactElement {
  const classes = useStyles();
  return <TimelineEventSvg className={classes.enlarged} />;
}

const useStyles = makeStyles((theme) => ({
  enlarged: {
    marginLeft: 4,
    marginBottom: 10,
    transform: 'scale(1.6)',
    willChange: 'transform', // smoother scroll (GPU driven)
  },
}));
